import { createSlice } from '@reduxjs/toolkit';
import { addReviewer, updateReviewer, getReviewers, getReviewer, deleteReviewer } from '../../actions/reviewerActions';
import { actionTypes } from '../../actionTypes';
// redux state
const initialState = {
  reviewer: undefined,
  error: '',
  isLoading: false,
};

// slice or reducer
const Reviewer = createSlice({
  name: 'Reviewer',
  initialState,
  // normal reducers
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
  },
  // async reducers
  extraReducers: (builder) => {
    caseReviewer(builder, addReviewer);
    caseReviewer(builder, updateReviewer);
    caseReviewer(builder, getReviewers);
    caseReviewer(builder, getReviewer);
    caseReviewer(builder, deleteReviewer);
  },
});
export default Reviewer.reducer;

const caseReviewer = (builder, action) => {
  builder.addCase(action.pending, (state) => {
    state.isLoading = true;
  });
  handleAllFulfillCases(builder, action);

  builder.addCase(action.rejected, (state) => {
    state.isLoading = false;
  });
};

const handleAllFulfillCases = (builder, action) => {
  builder.addCase(action.fulfilled, (state, action) => {
    // state updated in fulfilled state

    if (action.type.includes(actionTypes.ADD_REVIEWER)) {
      state.reviewer = action.payload;
      state.isLoading = false;
    } else if (action.type.includes(actionTypes.UPDATE_REVIEWER)) {
      state.isLoadingt = false;
      state.reviewer = action.payload;
    } else if (action.type.includes(actionTypes.GET_SINGLE_REVIEWER)) {
      state.reviewer = action.payload;
      state.isLoading = false;
    } else if (action.type.includes(actionTypes.GET_REVIEWERS)) {
      state.isLoading = false;
      state.reviewer = action.payload;
    } else if (action.type.includes(actionTypes.DELETE_REVIEWER)) {
      state.reviewer = action.payload;
      state.isLoading = false;
    }
  });
};
